import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle } from 'lucide-react';

const comparisonData = [
  { feature: "Session de cadrage offerte", start: true, test: true, proof: true },
  { feature: "Wireframes + UI design", start: true, test: true, proof: true },
  { feature: "Prototype interactif", start: true, test: true, proof: true },
  { feature: "Check-list \"Prêt pour le test\"", start: true, test: true, proof: true },
  { feature: "One-pager présentation", start: true, test: true, proof: true },
  { feature: "Mini scoring technique", start: true, test: true, proof: true },
  { feature: "Landing page de présentation", start: true, test: true, proof: true },
  { feature: "Mini deck de présentation", start: true, test: true, proof: true },
  { feature: "Tests utilisateurs réels", start: false, test: true, proof: true },
  { feature: "Dashboard KPI", start: false, test: true, proof: true },
  { feature: "Rapport d'analyse automatique", start: false, test: true, proof: true },
  { feature: "Score de validation par hypothèse", start: false, test: true, proof: true },
  { feature: "Replay sessions test", start: false, test: true, proof: true },
  { feature: "Template roadmap post-prototype", start: false, test: true, proof: true },
  { feature: "Audit UX express", start: false, test: true, proof: true },
  { feature: "Site de démo immersif", start: false, test: false, proof: true },
  { feature: "Vidéo de démo pro", start: false, test: false, proof: true },
  { feature: "Investor Deck + Pack", start: false, test: false, proof: true },
  { feature: "Mode \"Démo Pitch\"", start: false, test: false, proof: true },
  { feature: "Intégration IA / API", start: false, test: false, proof: true }
];

const ComparisonSection = () => {
  return (
    <section className="py-20 lg:py-24 bg-white">
      <div className="container px-4 mx-auto">
        <div className="max-w-6xl mx-auto">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
            viewport={{ once: true }}
            className="text-center mb-12"
          >
            <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-4">
              Comparatif express
            </h2>
          </motion.div>

          <div className="overflow-x-auto">
            <motion.table
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: 0.2 }}
              viewport={{ once: true }}
              className="w-full bg-white rounded-xl shadow-lg overflow-hidden"
            >
              <thead className="bg-slate-50">
                <tr>
                  <th className="px-6 py-4 text-left text-sm font-semibold text-slate-900">Élément</th>
                  <th className="px-6 py-4 text-center text-sm font-semibold text-slate-900">Start</th>
                  <th className="px-6 py-4 text-center text-sm font-semibold text-slate-900">Test</th>
                  <th className="px-6 py-4 text-center text-sm font-semibold text-slate-900">Proof</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-slate-200">
                {comparisonData.map((row, index) => (
                  <tr key={index} className="hover:bg-slate-50 transition-colors">
                    <td className="px-6 py-4 text-sm text-slate-700">{row.feature}</td>
                    <td className="px-6 py-4 text-center">
                      {row.start ? (
                        <CheckCircle className="w-5 h-5 text-orcsys-500 mx-auto" />
                      ) : (
                        <span className="text-slate-300">—</span>
                      )}
                    </td>
                    <td className="px-6 py-4 text-center">
                      {row.test ? (
                        <CheckCircle className="w-5 h-5 text-orcsys-500 mx-auto" />
                      ) : (
                        <span className="text-slate-300">—</span>
                      )}
                    </td>
                    <td className="px-6 py-4 text-center">
                      {row.proof ? (
                        <CheckCircle className="w-5 h-5 text-orcsys-500 mx-auto" />
                      ) : (
                        <span className="text-slate-300">—</span>
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </motion.table>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ComparisonSection;

